<template>
  <CommonPages id="terms-of-service" :class="['resources-page']" titlePrefix="Terms of Service"
    :metaDescription="domainConfig?.['meta']?.des || 'Terms of Service'">

    <div class="resources-row">
      <div class="resources">
        <!-- 页面主标题 -->
        <h2 class="resources__title">Terms of Service</h2>

        <div class="resources__content">
          <p>
            Welcome to {{ domainConfig?.siteName }}. By accessing or using our website, you agree to
            comply with and be bound by these Terms of Service. Please read them carefully.
          </p>
        </div>

        <!-- Eligibility -->
        <h3 class="resources__subtitle">Eligibility</h3>
        <div class="resources__content">
          <p>
            You must be at least 13 years old to use our website.
          </p>
        </div>

        <!-- License -->
        <h3 class="resources__subtitle">License</h3>
        <div class="resources__content">
          <p>
            We grant you a limited, non-exclusive, non-transferable license to access and use our
            site for personal, non-commercial purposes.
          </p>
        </div>

        <!-- User Conduct -->
        <h3 class="resources__subtitle">User Conduct</h3>
        <div class="resources__content">
          <p>
            You agree not to engage in any activity that may harm the website or its users,
            including but not limited to hacking, distributing malware, or violating any laws.
          </p>
        </div>

        <!-- Intellectual Property -->
        <h3 class="resources__subtitle">Intellectual Property</h3>
        <div class="resources__content">
          <p>
            All content is AI-generated and owned by {{ domainConfig?.siteName }}. You may not
            reproduce, distribute, or create derivative works without permission.
          </p>
        </div>

        <!-- Disclaimer of Warranties -->
        <h3 class="resources__subtitle">Disclaimer of Warranties</h3>
        <div class="resources__content">
          <p>
            Our website is provided "as is" without warranties of any kind.
          </p>
        </div>

        <!-- Limitation of Liability -->
        <h3 class="resources__subtitle">Limitation of Liability</h3>
        <div class="resources__content">
          <p>
            {{ domainConfig?.siteName }} is not liable for any damages arising from the use or
            inability to use our site.
          </p>
        </div>

        <!-- Changes to Terms -->
        <h3 class="resources__subtitle">Changes to Terms</h3>
        <div class="resources__content">
          <p>
            We may update these terms; continued use of the site indicates acceptance of the new
            terms.
          </p>
        </div>
      </div>
    </div>

  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'
import '@/css/resources.scss'

export default {
  name: 'TermsOfService',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  }
}
</script> 